export const bookingWebsiteOrigin = "https://fropp.io";

export function getBookingWebsiteUrl(shortName: string): string {
  return new URL(`/book/${encodeURIComponent(shortName)}`, bookingWebsiteOrigin).href;
}

export function getBookingWebsiteOpenUrl(shortName: string): string {
  return new URL(
    `/book/${encodeURIComponent(shortName)}`,
    import.meta.env.VITE_BOOKING_URL || bookingWebsiteOrigin,
  ).href;
}
